export const GroupThingTypeMrn = "mrn:sl2:iam::group";

export const DefaultGroups = {
  AdminGroup: "AdminGroup",
  UserGroup: "UserGroup",
};
